module.exports = __webpack_public_path__ + "img/favorite-inactive.eba62350.svg";